import React from "react";

import styled from "styled-components/macro";

export default function MaintenanceModeContent({
  line1,
  line2,
  line3,
  height = "100%",
}) {
  const maxWidth = 500;
  const screenWidth = window.innerWidth;
  const width = screenWidth >= maxWidth ? maxWidth : screenWidth - 20;

  return (
    <OuterWrapper height={height}>
      <Wrapper width={width}>
        <Icon>
          <span className="far fa-construction" />
        </Icon>

        <h1>Pardon our (virtual) sawdust!</h1>

        {line1 ? <h3>{line1}</h3> : null}
        {line2 ? <h3>{line2}</h3> : null}
        {line3 ? <h3>{line3}</h3> : null}

        <Help>
          Need help? Email the crew at{" "}
          <a href="mailto:help@flocknote.com" target="_blank" rel="noreferrer">
            help@flocknote.com
          </a>
          .
        </Help>
      </Wrapper>
    </OuterWrapper>
  );
}

const OuterWrapper = styled.div`
  width: 100%;
  height: ${(p) => p.height};
  display: grid;
  place-items: center;
`;

const Wrapper = styled.div`
  width: ${(p) => `${p.width}px`};
  max-width: 100%;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  text-wrap: balance;

  @media (max-width: 840px) {
    margin-top: 30px;
  }

  @media (max-height: 767px) {
    margin-top: 30px;
  }

  h1 {
    margin-top: 30px;
    font-size: 29px;
  }

  h3 {
    font-size: 19px;
    opacity: 0.8;
    margin-top: 30px;
    line-height: 1.5;
  }
`;

const Icon = styled.div`
  font-size: 68px;
  text-align: center;
  color: var(--fnBlue600);
`;

const Help = styled.div`
  font-size: 15px;
  font-weight: 400;
  opacity: 0.8;
  margin-top: 20px;
  line-height: 1.5;

  a {
    color: var(--fnBlue) !important;
  }
`;
